/**
 * Relateds API Operations Composable
 * Single Responsibility: Handles all API operations related to relateds
 */
import { httpService } from '../../services/HttpService';
import { apiConfig } from '../../services/ApiConfig';

export function useRelatedsApi() {
  /**
   * Load relateds data from API
   * @param {Object} params - Request parameters
   * @param {string} params.groupId - Group ID
   * @param {string} params.memberLineId - Member Line ID
   * @returns {Promise<Object>} API response data
   */
  const loadRelatedsData = async ({ groupId, memberLineId }) => {
    try {
      const url = apiConfig.getEndpoint('relateds', 'list', groupId || memberLineId, memberLineId);
      const data = await httpService.get(url);
      return data;
    } catch (error) {
      console.error('Failed to load relateds data:', error);
      throw new Error(`載入相關人員資料失敗: ${error.message}`);
    }
  };

  return {
    loadRelatedsData
  };
}